'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M24 14.757c0 2.24-1.726 4.103-3.92 4.244L19.247 19v2.333c-1.073-1.017-3.39-2.238-3.525-2.304l-.095-.018s-1.335.003-2.03.003h-.498c-1.258 0-2.445-.586-3.254-1.608l-.141-.192c.312.006.686.011 1.027.014h.086l.311.003h.532c3.126 0 5.668-2.583 5.668-5.758V7.225c0-.237-.018-.47-.046-.699l2.527-.002c2.312 0 4.192 1.91 4.192 4.258v3.975ZM5.08 18.525v-2.509h-.293l-.58.001C1.849 15.867 0 13.871 0 11.473V7.225c0-2.513 2.014-4.558 4.49-4.558h7.17c2.475 0 4.488 2.045 4.488 4.558v4.248c0 2.513-2.014 4.559-4.49 4.559h-.531c-.742 0-2.17-.004-2.207 0l-.096.029c-.027.014-2.6 1.368-3.745 2.464Zm-.816-8.197a.904.904 0 0 0 .897-.91.904.904 0 0 0-.897-.91.904.904 0 0 0-.896.91c0 .502.402.91.896.91Zm4.034 0a.904.904 0 0 0 .896-.91.904.904 0 0 0-.896-.91.904.904 0 0 0-.897.91c0 .502.402.91.897.91Zm4.033 0a.904.904 0 0 0 .896-.91.904.904 0 0 0-.896-.91.904.904 0 0 0-.896.91c0 .502.401.91.896.91Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
});
var SpeechBubbles = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.SpeechBubbles = SpeechBubbles;